<div class="row page-header">
    <div class="col-12">
        <h1>Fuel Records <small>View the Fuel Entries and export for import to Vista</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()" style="margin-bottom: 10px">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Summary View</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Export View</a>
        </li>
    </ul>
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <div [hidden]="active === 2">
                            <action-toolbar-buttons
                                [grid]="grid"
                                [canEdit]="canEdit"
                                [showAdd]="false"
                                [showEdit]="true"
                                [showDelete]="true"
                            ></action-toolbar-buttons>
                        </div>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Fuel Records'"></grid-export>
                        @if (canEdit) {
                            <button
                                type="button"
                                class="btn btn-sm btn-primary"
                                style="margin-left: 8px"
                                (click)="sendToVista()"
                                [disabled]="vistaSending"
                                title="Export a fuel batch to Vista for a chosen date range"
                            >
                                {{ vistaSending ? 'Sending to Vista...' : 'Export to Vista' }}
                            </button>
                        }
                    </form>
                </div>
            </div>
            @if (vistaStatus) {
                <div class="row">
                    <div class="col-12">
                        <div
                            class="alert"
                            [class.alert-info]="!vistaStatus.isTerminal"
                            [class.alert-success]="vistaStatus.status === 'Succeeded'"
                            [class.alert-danger]="vistaStatus.status === 'Failed'"
                            [class.alert-warning]="vistaStatus.status === 'TimedOut'"
                        >
                            <strong>Vista Import:</strong> {{ vistaStatus.status }} — {{ vistaStatus.rowCount }} records (file
                            {{ vistaStatus.fileName }}).
                            @if (!vistaStatus.isTerminal) {
                                <span> Monitoring Vista for results...</span>
                            }
                            @if (vistaStatus.failureSummary) {
                                <div style="margin-top: 8px">
                                    <strong>What happened:</strong> {{ vistaStatus.failureSummary }}
                                </div>
                            }
                            @if (vistaStatus.errorText || vistaStatus.logText) {
                                <details style="margin-top: 8px">
                                    <summary>Vista details</summary>
                                    <pre style="white-space: pre-wrap; margin-top: 8px; margin-bottom: 0">{{ vistaStatus.errorText || vistaStatus.logText }}</pre>
                                </details>
                            }
                        </div>
                    </div>
                </div>
            }
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        [itemFormatter]="itemFormatter"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Id'"
                            [binding]="'indexId'"
                            [format]="'d'"
                            [width]="80"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Month'"
                            [binding]="'monthDate'"
                            [format]="'MM/dd/yyyy'"
                            [width]="100"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Date'"
                            [binding]="'date'"
                            [format]="active === 1 ? 'MM/dd/yyyy hh:mm tt' : 'MM/dd/yyyy'"
                            [width]="active === 1 ? 180 : 100"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Lifetime Meter'"
                            [binding]="'lifetimeMeter'"
                            [width]="110"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Lifetime Meter Id'"
                            [binding]="'lifetimeMeterId'"
                            [width]="110"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Fuel Out'"
                            [binding]="'source'"
                            [width]="110"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Fuel Type Out'"
                            [binding]="'fuelTypeOut'"
                            [width]="70"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="active === 1 ? 'Fuel In' : 'Equipment#'"
                            [binding]="'vehicle'"
                            [width]="130"
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Fuel Type In'"
                            [binding]="'fuelTypeIn'"
                            [width]="70"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Cost Code'"
                            [binding]="'costCode'"
                            [width]="140"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Cost Type'"
                            [binding]="'costType'"
                            [width]="140"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Offset GL'"
                            [binding]="'account'"
                            [width]="140"
                            [format]="'d'"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="active === 1 ? 'Gallons' : 'Units'"
                            [binding]="'gallons'"
                            [width]="115"
                            [format]="'N1'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sequence #'"
                            [binding]="'sequence'"
                            [width]="130"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Batch'"
                            [binding]="'batch'"
                            [width]="110"
                            [format]="'d'"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Trans Type'"
                            [binding]="'transType'"
                            [width]="140"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Measurement'"
                            [binding]="'um'"
                            [width]="80"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="active === 1 ? 'Avg Price' : 'Unit Price'"
                            [binding]="'avgPrice'"
                            [width]="130"
                            [format]="active === 1 ? 'c5' : 'n5'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="active === 1 ? 'Hour Meter' : 'Meter Reading'"
                            [binding]="'meter'"
                            [width]="140"
                            [format]="'d'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Fuel Out'"
                            [binding]="'source'"
                            [width]="110"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Amount'"
                            [binding]="'amount'"
                            [width]="110"
                            [format]="'n2'"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'User'"
                            [binding]="'userName'"
                            [width]="180"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job'"
                            [binding]="'jobId'"
                            [width]="90"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Last Modified By'"
                            [binding]="'lastModifiedByName'"
                            [width]="180"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Last Modified On'"
                            [binding]="'lastModifiedOn'"
                            [format]="'MM/dd/yy hh:mm tt'"
                            [width]="180"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
